
<div class="list-header d-flex justify-content-between align-items-center profile-review-list-container">
     <header class="page-header">
        <div class="page-header__left">
            <p class="page-header__title">
                {{ 'cadreManagement' | translate }}
            </p>
            <div class="page-header__breadcrumb">
                <span> {{ 'master' | translate }} </span>
                <span>
                    &nbsp;<i class="fa-solid fa-caret-right">&nbsp;&nbsp;<span style="font-size: .875rem;
                font-weight: 500;">{{'role' | translate}}</span></i>&nbsp;
                </span>

            </div>
        </div>
    </header>
</div>
<form [formGroup]="roleForm">
    <div class="row">
        <div class="form-group col-md-4">
            <label for="thematicName" class="form-label">{{'verticalName'|translate}} <span class="required">*</span></label>
            <input id="thematicName" type="text" formControlName="thematicName" class="form-control" readonly />

        </div>

        <div class="form-group col-md-4">
            <label for="roleName" class="form-label">{{'roleName'|translate}} <span class="required">*</span></label>
            <input id="roleName" type="text" formControlName="roleName" class="form-control" readonly />
        </div>
    </div>
</form>